module.exports = __webpack_public_path__ + "static/img/lacan3.691bd79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lacan3.jpg
// module id = 555
// module chunks = 2